<template>
  <div v-tooltip:top="'Atzīmēt dzēšanai'" class="deleteAction" :class="{'active': active}" @click="markForDelete(description.id)">
    <span class="material-icons">delete_sweep</span>
  </div>
</template>

<script>
export default {
  props:['description'],
  mounted() {
    if(this.$props.description.moved_to_delete_state)
    {
      this.active = true;
    }
  },
  data()
  {
    return{
      active:false,

    }
  },
  methods: {
    markForDelete(id)
    {
      var that = this;
      axios.post('/dashboard/api/scientific-description/'+id+'/toggleDeleteState')
          .then(response => {
            if(response.data.status == 'ok')
            {
              that.$toast.open({
                message:response.data.message,
                position: 'top-right'
              });
              if(response.data.delete_state === 1)
              {
                this.active = true;
              }
              else {
                this.active = false;
              }
            }
          })
    }
  }


}
</script>

<style lang="scss" scoped>
@use "sass:color";
@import '../../../sass/variables';

.deleteAction{
  margin-left:5px;
  color:#bbb;
  padding:10px;
  cursor: pointer;
  transition: all .2s;
  &:hover{
    color: #aaa;
  }
  &.active{
    color:$red;
  }
}

</style>